import React from "react";
import { X } from "@untitledui/icons";

import { SEVERITY_STYLE } from "./severity";
import type { ActiveAnnouncement } from "../../hooks/useAnnouncement";

interface Props {
  active: ActiveAnnouncement;
  onDismiss?: () => void;
}

export const AnnouncementBanner: React.FC<Props> = ({ active, onDismiss }) => {
  const style = SEVERITY_STYLE[active.severity];
  const Icon = style.Icon;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: 12,
        padding: "10px 16px",
        fontSize: 13,
        fontWeight: 500,
        background: style.bg,
        color: style.fg,
        borderBottom: `1px solid ${style.border}`,
      }}
      role="status"
      aria-live="polite"
    >
      <Icon className="w-5 h-5" />
      <div style={{ flex: 1, minWidth: 0 }}>
        {active.title && (
          <div style={{ fontWeight: 600, marginBottom: 2 }}>{active.title}</div>
        )}
        <div style={{ opacity: 0.95 }}>{active.message}</div>
      </div>
      {active.dismissible && onDismiss && (
        <button
          onClick={onDismiss}
          aria-label="Dismiss announcement"
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 4,
            color: style.fg,
            opacity: 0.7,
            lineHeight: 0,
          }}
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};
